import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Title from '../../commonComponents/Title';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import translate from '../../commonComponents/translate';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import HardSkillProp from './propTypes/hardSkillProp';
import RecommendationForm from './recommendationDetails/RecommendationForm';
import GameRecommendationProp from './propTypes/gameRecommendationProp';
import LoggedUserContext from '../../contextProviders/LoggedUserContext';

function RecommendationDetails(props) {
  const { loggedUser } = useContext(LoggedUserContext);

  const {
    t,
    isEdit,
    countries,
    languages,
    experienceDomainSkills,
    hardSkills,
    recommendation: initialRecommendation,
    gameId,
  } = props;

  const title = isEdit
    ? t('recommendationDetails_head_title')
    : t('recommendationDetails_head_createTitle');

  const subheader = isEdit
    ? t('recommendationDetails_title')
    : t('recommendationDetails_createTitle');

  const recommendation = isEdit
    ? initialRecommendation
    : { game: gameId, referencedBy: loggedUser._id };

  const linkGameId = isEdit ? initialRecommendation.game : gameId;

  return (
    <Title title={title}>
      <ContentContainer>
        <SubHeader
          title={subheader}
          breadcrumbs={[
            { link: '/challenges', text: t('header_performance_challenges') },
            {
              link: `/challenges/${linkGameId}`,
              text: t('header_performance_challengeDetails'),
            },
            {
              link: `/challenges/${linkGameId}/recommendations`,
              text: t('header_performance_challengeDetails_recommendations'),
            },
            { link: '', text: subheader },
          ]}
        />
        <div className="m-content">
          <div className="row full-page-container-with-subheader">
            <div className="col-lg-12">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__body">
                  <RecommendationForm
                    isEdit={isEdit}
                    countries={countries}
                    languages={languages}
                    experienceDomainSkills={experienceDomainSkills}
                    hardSkills={hardSkills}
                    recommendation={recommendation}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

RecommendationDetails.propTypes = {
  t: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  experienceDomainSkills: PropTypes.arrayOf(PropTypes.string).isRequired,
  hardSkills: PropTypes.arrayOf(PropTypes.shape(HardSkillProp.propType))
    .isRequired,
  recommendation: PropTypes.shape(GameRecommendationProp.propType),
  gameId: PropTypes.string,
};

RecommendationDetails.defaultProps = {
  recommendation: null,
  gameId: null,
};

export default translate(RecommendationDetails);
